import axios from 'axios'

export default {
    getFileThumbnails (fileId) {
        return axios.get('/api/files/' + fileId + '/thumbnails')
    },
    getAllFilesThumbnails (fileIds) {
        return axios.post('/api/files/thumbnails', {
            file_ids: fileIds
        })
    }
}
